import api from './index';

const postUser = (data) => api.post('/addUser', data);

const getUser = () => api.get('/getUser');

const deleteUser = (data) => api.post('/deleteUser', data);

const editUser = (data) => api.post('/editUser', data);

const editPermission = (data) => api.post('/editUserPermission', data);

export {
  postUser, getUser, deleteUser, editUser, editPermission,
};
